module.exports = __webpack_public_path__ + "img/hr-level2addon_running_shadow.0bbcbe1d.png";